import { render, staticRenderFns } from "./CarepForm.vue?vue&type=template&id=12f0783e&scoped=true"
import script from "./CarepForm.vue?vue&type=script&lang=js"
export * from "./CarepForm.vue?vue&type=script&lang=js"
import style0 from "./CarepForm.vue?vue&type=style&index=0&id=12f0783e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f0783e",
  null
  
)

export default component.exports